<template>
  <div class="flex items-center">
    <RevRating :score size="extra-small" />
    <span class="text-static-default-hi caption ml-4">
      ({{ i18n.number(count) }})
    </span>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevRating } from '@ds/components/Rating'

defineProps<{
  score: number
  count: number
}>()

const i18n = useI18n()
</script>
